<template>
  <v-card
    tile
    elevation="1"
  >
    <v-list-item
      v-for="model in models"
      :key="`model-${model.id}`"
      @click="index(model)"
    >
      <template #default>
        <v-list-item-icon>
          <v-icon
            :color="isMissingTranslations(model) ? 'orange' : 'green'"
            v-text="isMissingTranslations(model) ? 'mdi-alert-circle' : 'mdi-check-circle'"
          />
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            <i
              v-if="! isSubcategories && model.icon"
              :class="model.icon"
              class="pr-1"
            />
            {{ model.default_translation.name }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  props: {
    faqId: {
      type: Number,
      required: true
    },
    models: {
      type: Array,
      required: true
    },
    isSubcategories: {
      type: Boolean
    },
    missingTranslations: {
      type: Object,
      required: true
    }
  },


  methods: {
    index(model) {
      let url;
      if (! this.isSubcategories) {
        url = this.route('faq.category-translation.index', {
          faq: this.faqId,
          category: model.id
        });
      } else {
        url = this.route('faq.subcategory-translation.index', {
          faq: this.faqId,
          subcategory: model.id
        });
      }

      this.$inertia.get(url, {}, {
        preserveState: true,
        preserveScroll: true
      });
    },

    isMissingTranslations(model) {
      if (this.isSubcategories) {
        return model.translations.some(translation => {
            return this.missingTranslations.subcategories[model.id][translation.language_code];
        });
      } else {
        return model.translations.some(translation => {
            return this.missingTranslations.categories[model.id][translation.language_code];
        });
      }
    }
  },
}
</script>